import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import FormInput from "app/Components/_form/FormInput/FormInput";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import IconSelect from "app/Components/_form/FormSelect/IconSelect";
import React from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { components } from "react-select/dist/react-select.cjs.prod";
import { highSeverities } from "../../IncidentManagement/CONSTANTS";
import { OBSERVATIONS_SEVERITY, OBSERVATION_TYPE, POTENTIAL } from "../CONSTANTS";

export const OBSERVATION_CATEGORY = [
  { label: "Unsafe Act", id: "unsafeAct" },
  { label: "Unsafe Condition", id: "unsafeCondition" },
  { label: "Safe Act", id: "safeAct" },
  { label: "Safe Condition", id: "safeCondition" },
  { label: "Near Miss", id: "nearMiss" },
  { label: "MTI (Medical Treatment Injury)", id: "MTI" },
  { label: "LTI (Lost Time Injury)", id: "LTI" },
  { label: "Serious bodily injury", id: "SBI" },
  { label: "Fatality", id: "fatality" },
];

export const OBSERVATION_SUB_CATEGORY = [
  { label: "Unsafe Act", id: "unsafeAct" },
  { label: "Unsafe Condition", id: "unsafeCondition" },
  { label: "Safe Act", id: "safeAct" },
  { label: "Safe Condition", id: "safeCondition" },
  { label: "Near Miss", id: "nearMiss" },
  { label: "MTI (Medical Treatment Injury)", id: "MTI" },
  { label: "LTI (Lost Time Injury)", id: "LTI" },
  { label: "Serious bodily injury", id: "SBI" },
  { label: "Fatality", id: "fatality" },
];

const { Option } = components;

function ObservationTab({
  category = [],
  dataArray = [],
  errorArray = [],
  onChange = () => { },
  onChangeFile = () => { },
  onAdd = () => { },
  onDelete = () => { },
  viewOnly,
}) {
  const IconOption = (props) => {
    console.log("props", props);
    return (
      <Option {...props}>
        {props.data.label}

        <div className="position-absolute" style={{ right: "4px", marginTop: "-20px" }}>
          <CustomTooltip placement="top" tooltip={props.data.tooltip}>
            <BsFillInfoCircleFill />
          </CustomTooltip>
        </div>
      </Option>
    );
  };
  return (
    <div className="table-responsive drillingPlan-plannedEdit">
      <table id="user_table" className="table table-bordered mb-3">
        <thead>
          <tr>
            <th scope="col">Observation</th>
            <th scope="col">Type</th>
            <th scope="col">Category</th>
            <th scope="col">Sub-Category</th>
            <th scope="col">Potential</th>
            <th scope="col">
              Severity{" "}
              <CustomPopover
                placement={"right"}
                tooltip={
                  <>
                    <table className="table table-bordered tooltipTable">
                      <thead>
                        <tr>
                          <th>Observations Severity</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {OBSERVATIONS_SEVERITY.map((x) => {
                          return (
                            <tr>
                              <td>{x.label}</td>
                              <td>{x.tooltip}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                }
              >
                <BsFillInfoCircleFill />
              </CustomPopover>
            </th>

            {!viewOnly && <th scope="col">Remove</th>}
          </tr>
        </thead>
        <tbody>
          {dataArray.length > 0 ? (
            dataArray.map((x, index) => {
              const subCategory =
                category.find((d) => d.id === +x?.category)?.subCategory || [];
              return x?.deleted ? null : (
                <tr key={index}>
                  <th>
                    <FormInput
                      value={x?.observation}
                      name="observation"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      disabled={viewOnly}
                    // error={errorArray[index]?.observation}
                    />
                  </th>
                  <th>
                    <FormSelect
                      value={x.type}
                      name="type"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      options={OBSERVATION_TYPE}
                      disabled={viewOnly}
                    // error={errorArray[index]?.type}
                    />
                  </th>
                  <th>
                    <FormSelect
                      value={x.category}
                      name="category"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      options={category.map((d) => ({
                        label: d.name,
                        id: d.id,
                      }))}
                      disabled={viewOnly}
                    // error={errorArray[index]?.category}
                    />
                  </th>
                  <th>
                    <FormSelect
                      value={x.subCategory}
                      name="subCategory"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      options={subCategory.map((d) => ({
                        label: d.name,
                        id: d.id,
                      }))}
                      disabled={viewOnly}
                    // error={errorArray[index]?.subCategory}
                    />
                  </th>
                  <th>
                    <FormSelect
                      value={x.potential}
                      name="potential"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      options={POTENTIAL}
                      disabled={viewOnly}
                    // error={errorArray[index]?.potential}
                    />
                  </th>
                  <th>
                    <FormSelect
                      value={x.severity}
                      name="severity"
                      onChange={({ target: { name, value } }) =>
                        onChange({ name, value, index })
                      }
                      options={OBSERVATIONS_SEVERITY}
                      disabled={viewOnly}
                    // error={errorArray[index]?.severity}
                    // component={IconOption}
                    />
                  </th>
                  {!viewOnly && (
                    <td>
                      <div className="actionIconsGroup">
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                        >
                          <span
                            onClick={() => onDelete(index)}
                            className="pointer icons text-danger font-20"
                          >
                            <FiMinusCircle />
                          </span>
                        </OverlayTrigger>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="10" align="center">
                {/* <div className="alert alert-danger d-inline-block m-0">
                                <strong>No Evidence</strong>
                            </div> */}
              </td>
            </tr>
          )}
          {!viewOnly && (
            <tr>
              <td colSpan="10">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">Add Row</Tooltip>}
                >
                  <Button className="addRowPluseIcon" onClick={onAdd}>
                    <FiPlusCircle />
                  </Button>
                </OverlayTrigger>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ObservationTab;
